import {useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import ModalButtons from './components/modalButtons/index.js'
import ModalButtonsV2 from './components/modalButtons/indexv2.js'
import ModalContent from './components/modalContent/index.js'
import {BASE_CLASS, STEPS_INITIAL_STATE, TEST_ID} from './config/index.js'

export default function ModalBasicContent({stepsContent = []}) {
  const [contentStep, setContentStep] = useState(STEPS_INITIAL_STATE)

  const hasSteps = stepsContent.length > 1
  const contentExists = stepsContent.length > 0

  const {
    buttons = {},
    buttonsContent = null,
    buttonsLayout,
    captionText,
    children,
    forceInlineButtons = false,
    headerImage,
    isVerticallyCentered,
    renderButtonsV2 = false,
    title,
    titleSize = 's'
  } = contentExists && stepsContent[contentStep]

  const checkCallback = callback => {
    const nextStep = contentStep === 2 ? 0 : contentStep + 1
    return Boolean(callback) && typeof callback === 'function' ? callback(nextStep) : () => {}
  }
  const handleConfirmButton = () => {
    if (hasSteps) setContentStep(contentStep + 1)
    checkCallback(buttons?.confirmButton?.customCallBack)
  }

  const handleCancelButton = () => {
    if (hasSteps) setContentStep(STEPS_INITIAL_STATE)
    checkCallback(buttons?.cancelButton?.customCallBack)
  }

  const handleSteps = step => setContentStep(step)

  const steps = hasSteps ? Array.from({length: stepsContent.length}, (item, i) => i) : []

  const stepClassName = isSelected =>
    cx(`${BASE_CLASS}-step`, {
      'is-selected': isSelected
    })

  const hasButtons = buttons !== undefined && Object.keys(buttons).length > 0
  const buttonsLength = hasButtons && Object.keys(buttons).length

  const contentClassName = cx(`${BASE_CLASS}`, {
    [`${BASE_CLASS}--hasButton`]: hasButtons && buttonsLength === 1,
    [`${BASE_CLASS}--hasButtonAndFooterText`]: hasButtons && buttonsLength === 1 && buttonsContent !== null,
    [`${BASE_CLASS}--hasButtons`]: hasButtons && buttonsLength === 2,
    [`${BASE_CLASS}--hasFullFooter`]: hasButtons && buttonsLength === 2 && buttonsContent !== null,
    [`${BASE_CLASS}--verticallyCentered`]: isVerticallyCentered
  })

  return (
    <>
      {contentExists && (
        <div className={contentClassName}>
          <ModalContent
            captionText={captionText}
            children={children}
            headerImage={headerImage}
            title={title}
            titleSize={titleSize}
          />
          {(hasSteps || hasButtons) && (
            <div className="mt-ModalBasicContent-bottomContent">
              {hasSteps && (
                <div className={`${BASE_CLASS}-steps`}>
                  {steps.map(item => (
                    <div
                      className={stepClassName(item === contentStep)}
                      data-testid={`${TEST_ID}${item}`}
                      key={item}
                      onClick={() => handleSteps(item)}
                    />
                  ))}
                </div>
              )}
              {renderButtonsV2
                ? hasButtons && (
                    <ModalButtonsV2
                      buttons={buttons}
                      buttonsContent={buttonsContent}
                      buttonsLayout={buttonsLayout}
                      forceInlineButtons={forceInlineButtons}
                      handleConfirmButton={handleConfirmButton}
                      handleCancelButton={handleCancelButton}
                    />
                  )
                : hasButtons && (
                    <ModalButtons
                      buttons={buttons}
                      buttonsContent={buttonsContent}
                      forceInlineButtons={forceInlineButtons}
                      handleConfirmButton={handleConfirmButton}
                      handleCancelButton={handleCancelButton}
                    />
                  )}
            </div>
          )}
        </div>
      )}
    </>
  )
}

ModalBasicContent.displayName = 'ModalBasicContent'
ModalBasicContent.propTypes = {
  stepsContent: PropTypes.arrayOf(
    PropTypes.shape({
      buttons: PropTypes.shape({
        confirmButton: {
          customCallBack: PropTypes.func,
          isDisabled: PropTypes.bool,
          text: PropTypes.string,
          type: PropTypes.string
        },
        cancelButton: {
          customCallBack: PropTypes.func,
          isDisabled: PropTypes.bool,
          text: PropTypes.string,
          type: PropTypes.string
        }
      }),
      buttonsContent: PropTypes.node,
      buttonsLayout: PropTypes.string,
      captionText: PropTypes.string,
      children: PropTypes.node,
      forceInlineButtons: PropTypes.bool,
      headerImage: PropTypes.node,
      isVerticallyCentered: PropTypes.bool,
      // temp prop to test ModalButtonsV2
      renderButtonsV2: PropTypes.bool,
      title: PropTypes.string,
      titleSize: PropTypes.string
    })
  )
}
